import { render, staticRenderFns } from "./ImportOrderForm.vue?vue&type=template&id=01fa5e61&lang=pug"
import script from "./ImportOrderForm.vue?vue&type=script&lang=js"
export * from "./ImportOrderForm.vue?vue&type=script&lang=js"
import style0 from "./ImportOrderForm.vue?vue&type=style&index=0&id=01fa5e61&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports